<template>
  <BaseTemplate :currentUser="currentUser" :isTop="true">
    <div v-if="packList" class="top">
      <!-- <TopIconArea></TopIconArea> -->
      <PackMenuList :cardTypeList="availableCardTypes"></PackMenuList>

      <div class="_pack_list" v-if="-1 == showCardType && showCardType != 11">
        <span v-if="!inputBoard">
          <div class="post_button_area">
            <BlackGradationButton
              class="square-button"
              text="entry post"
              @handleSquareBtnClick="showInputArea"
            />
          </div>
          <span v-if="postItemList.length > 0">
            <div
              class="post_list"
              v-for="(postItem, i) in postItemList"
              :key="i"
            >
              <div class="_title">
                <span>
                  {{ postItem.name }}
                </span>
                <span>
                  {{ postItem.created }}
                </span>
              </div>
              <div class="content">{{ postItem.content }}</div>
              <div class="images">
                <div
                  class="image"
                  v-for="(image, j) in postItem.images"
                  :key="j"
                >
                  <img :src="image" alt="" @click="clickImage(image)" />
                </div>
              </div>
            </div>
            <BoxPager
              v-if="page && page.pages.length > 0"
              class="box-pager"
              :totalPageCount="page.all_page"
              :currentPageCount="page.page"
              :dispBoxCount="page.pages.length"
              :pages="page.pages"
              @handlePagerClick="changeCurrentPageCount"
              @handleSquareBtnClick="changeCurrentPageCount"
            />
          </span>
          <div v-else class="no_item_list">message empty</div>
        </span>
        <PostNewArea
          v-else
          @handleBtnClick="savePost"
          @handleBackBtnClick="closeSavePost"
        ></PostNewArea>
      </div>

      <!-- <div class="_pack_list" v-if="-1 == showCardType">
        <div class="twitter_block">
          <iframe src="/twitter.html"></iframe>
        </div>
      </div> -->
      <span v-for="(cardType, i) in cardTypeList" :key="i">
        <div class="_pack_list" v-if="cardType.id == showCardType">
          <div class="product-list">
            <ProductBanner
              v-for="packItem in productList[cardType.id]"
              :key="packItem.id"
              class="banner"
              :data-pack-id="packItem.id"
              :packItem="packItem"
              :currentUser="currentUser"
              :top="true"
              @handleCardHide="CardHideChange"
              @handleLoginClick="goToLogin"
              @handleBuyClick="goToConfirmBuyProduct"
            />
          </div>
        </div>
      </span>
      <div class="_pack_list">
        <div class="product-list" v-if="999995 == showCardType">
          <ProductBanner
            v-for="packItem in productList[999995]"
            :key="packItem.id"
            class="banner"
            :data-pack-id="packItem.id"
            :packItem="packItem"
            :currentUser="currentUser"
            :top="true"
            @handleCardHide="CardHideChange"
            @handleLoginClick="goToLogin"
            @handleBuyClick="goToConfirmBuyProduct"
          />
        </div>
        <div class="product-list" v-if="999996 == showCardType">
          <ProductBanner
            v-for="packItem in productList[999996]"
            :key="packItem.id"
            class="banner"
            :data-pack-id="packItem.id"
            :packItem="packItem"
            :currentUser="currentUser"
            :top="true"
            @handleCardHide="CardHideChange"
            @handleLoginClick="goToLogin"
            @handleBuyClick="goToConfirmBuyProduct"
          />
        </div>
      </div>
    </div>
    <CommonOverlay class="overlay" v-show="isImageModal">
      <CommonModal class="modal">
        <div>
          <img class="overlay_image" :src="imageUrl" alt="" />
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="isImageModal = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay
      class="overlay"
      v-show="hideCard"
      @handleOverlayClick="hideCard = false"
    >
      <CommonModal class="modal">
        <div>
          {{ t('本商品の内容は全て非公開となります。') }}
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="hideCard = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay register-country" v-show="isCountryPopup">
      <CommonModal class="modal">
        <div class="register-country-title">
          In order to prevent unauthorized access, we ask for your cooperation
          in selecting the country name.
        </div>
        <SelectBox
          class="register-country-select"
          :options="countryList"
          :selectedOption="countryId"
          @handleSelectChange="changeCountry"
        />
        <ErrorMessage
          v-if="errorMessageCountryId"
          class="error-message"
          :message="errorMessageCountryId"
        />
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="save"
            :isSub="true"
            @handleSquareBtnClick="saveCountry"
          />
        </div>
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay_conf" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <GrayCloseButton
          class="close_button"
          @handleClick="closeModal"
        ></GrayCloseButton>
        <div class="block">
          <div>{{ buyCoin | comma }}{{ t('ポイントを')}}</div>
          <div>{{ t('消費して') }}<br>{{ count }}{{ t('回ガチャを引く') }}</div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            @handleSquareBtnClick="buyPack"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import { separateCharacterNumber } from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
// import TopIconArea from '@/components/molecules/TopIconArea.vue';
// import ShadowButton from '@/components/molecules/ShadowButton.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import PostNewArea from '@/components/molecules/PostNewArea.vue';
// import RoundButton from '@/components/atoms/RoundButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import GrayCloseButton from '@/components/atoms/GrayCloseButton.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import PackMenuList from '@/components/pages/Top/PackMenuList.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';

export default {
  name: 'Top',

  components: {
    BaseTemplate,
    ProductBanner,
    // TopIconArea,
    // ShadowButton,
    BlackGradationButton,
    PostNewArea,
    BoxPager,
    // RoundButton,
    CommonOverlay,
    CommonModal,
    GrayCloseButton,
    SquareButton,
    SelectBox,
    ErrorMessage,
    PackMenuList,
    SimpleButton,
  },

  data: () => ({
    productList: [],
    inputBoard: false,
    // showCardType: 1,
    isImageModal: false,
    imageUrl: '',
    isCountryPopup: false,
    countryId: '',
    errorMessageCountryId: null,
    errorMessageCount: null,
    isOpenConfirm: false,
    currentPack: null,
    count: 1,
    hideCard: false,
    targetPackId: null,
    shouldScrollToPack: false,
    availableCardTypes: [],
    cardTypeRestored: false,
  }),
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/cardTypeList',
      showCardType: 'pack/topCardType',
      postList: 'post/postList',
      page: 'post/page',
      countryCheckResult: 'country/countryCheckResult',
      countryList: 'country/countryList',
      changeUserInformationResult: 'user/changeUserInformationResult',
      packCheckResult: 'pack/packCheckResult',
      buyPackResult: 'pack/buyPackResult',
      currentLanguage: 'user/currentLanguage',
    }),
    postItemList() {
      if (this.postList.list) {
        const formattedItemList = this.postList.list.map(
          (item) => ({
            ...item,
            name:
              process.env.VUE_APP_LANG_MODE === 'en'
                ? `${item.lastName} ${item.middleName} ${item.firstName}`
                : `${item.lastName} ${item.firstName}`,
          }),
          [],
        );
        return formattedItemList;
      }
      return [];
    },
    buyCoin() {
      if (this.currentPack) {
        return this.currentPack.point * this.count;
      }
      return 0;
    },
  },
  watch: {
    packList(newList) {
      // 前回のデータをクリア
      this.productList = [];
      for (let i = 0; i < newList.list.length; i += 1) {
        const isBonus = newList.list[i].is_bonus === 1 || newList.list[i].is_bonus === '1';
        if (isBonus) {
          // ボーナスパックはボーナスタブのみに表示
          if (!this.productList[999995]) {
            this.productList[999995] = [];
          }
          this.productList[999995].push(newList.list[i]);
        } else {
          // 通常パックは元のカードタイプに表示
          const idx = newList.list[i].card_type;
          if (!this.productList[idx]) {
            this.productList[idx] = [];
          }
          this.productList[idx].push(newList.list[i]);
        }
      }
      // パックリストが読み込まれた後、指定されたパックIDにスクロール
      if (this.shouldScrollToPack && this.targetPackId) {
        this.$nextTick(() => {
          this.scrollToPackId(this.targetPackId);
          this.shouldScrollToPack = false;
          this.targetPackId = null;
        });
      }
      // availableCardTypesを更新し、初期選択を行う
      this.$nextTick(() => {
        this.updateAvailableCardTypes();
        // URLにcardTypeパラメータがある場合はそれを優先
        const urlCardType = this.$route.query.cardType;
        if (urlCardType) {
          // URLパラメータがある場合は上書きしない
          return;
        }
        // sessionStorageから復元済みの場合は上書きしない
        if (this.cardTypeRestored) {
          return;
        }
        // 初期表示はログイン（999995）を優先、なければ最初のタイトルを選択
        if (this.availableCardTypes.length > 0) {
          const login = this.availableCardTypes.find(
            (cardType) => cardType.id === 999995,
          );
          this.$store.dispatch('pack/setTopCardType', login ? login.id : this.availableCardTypes[0].id);
        }
      });
    },
    // countryCheckResult() {
    //   if (this.countryCheckResult) {
    //     if (this.countryCheckResult.is_login && !this.countryCheckResult.is_country) {
    //       this.$router.push({ path: '/user-address' });
    //     }
    //   }
    // },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isCountryPopup = false;
        } else {
          const { country_id: countryId } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
        }
      }
    },
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          // const query = {
          //   packId: this.$route.query.packId,
          //   buyCount: this.count,
          // };
          this.$store.dispatch('pack/clearPackCheckResult');
          // this.$router.push({ path: '/confirm-buy-product', query });
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          alert(this.errorMessageCount);
        }
      }
    },
    cardTypeList() {
      // カードタイプリストが更新された時にavailableCardTypesを更新
      this.$nextTick(() => {
        this.updateAvailableCardTypes();
      });
    },
    availableCardTypes(newCardTypes) {
      if (newCardTypes && newCardTypes.length > 0) {
        // URLにcardTypeパラメータがある場合はそれを優先
        const urlCardType = this.$route.query.cardType;
        if (urlCardType) {
          return;
        }
        const currentCardTypeExists = newCardTypes.some((cardType) => cardType.id === this.showCardType);
        if (!currentCardTypeExists) {
          // ログイン（999995）を優先、なければ最初のタイプを選択
          const login = newCardTypes.find((cardType) => cardType.id === 999995);
          this.$store.dispatch('pack/setTopCardType', login ? login.id : newCardTypes[0].id);
        }
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    // ページ離脱時に現在のカードタイプを保存（戻った時に復元するため）
    const cardType = this.$store.getters['pack/topCardType'];
    if (cardType) {
      sessionStorage.setItem('lastCardType', String(cardType));
    }
    next();
  },

  created() {
    this.$store.dispatch('pack/setPackList');
    this.$store.dispatch('cardType/setCardTypeList');
    // this.$store.dispatch('post/getPostList', { pageNumber: 1 });
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('country/setCountryCheckResult');
    const { apple, login_error: loginError } = this.$route.query;
    if (apple || loginError) {
      this.$store.dispatch('user/setShowLoginPage', true);
    }
    // URLパラメータからカードタイプとパックIDを取得
    const { cardType, packId } = this.$route.query;
    if (cardType) {
      // カードタイプを自動選択
      this.$store.dispatch('pack/setTopCardType', Number(cardType));
      // パックIDが指定されている場合、スクロール処理を予約
      if (packId) {
        this.targetPackId = packId;
        this.shouldScrollToPack = true;
      }
    }
    // sessionStorageからカードタイプを復元（パック詳細から戻った場合）
    const savedCardType = sessionStorage.getItem('lastCardType');
    if (savedCardType) {
      sessionStorage.removeItem('lastCardType');
      this.cardTypeRestored = true;
      this.$store.dispatch('pack/setTopCardType', Number(savedCardType));
    } else if (!cardType) {
      // デフォルトでログイン（ボーナス=999995）を選択
      this.$store.dispatch('pack/setTopCardType', 999995);
    }
    // availableCardTypesの初期化（データが既に存在する場合）
    this.$nextTick(() => {
      this.updateAvailableCardTypes();
    });
  },

  methods: {
    updateAvailableCardTypes() {
      if (!this.cardTypeList || !Array.isArray(this.cardTypeList)) {
        this.availableCardTypes = [];
        return;
      }
      const filtered = [];
      // ログイン（ボーナスパック, 999995）を先頭に追加
      if (this.productList[999995] && this.productList[999995].length > 0) {
        filtered.push({ id: 999995, name: 'ログイン' });
      }
      // 指定順序のカードタイプ名
      const orderedNames = [
        '遊戯王',
        'ポケモン',
        'ポケットモンスター',
        'ヴァイスシュバルツ',
        'アーセナルベース',
        'ドラゴンボール',
        'ワンピース',
        'ユニオンアリーナ',
        'ホロライブ',
      ];
      const addedIds = new Set();
      // 指定順序でカードタイプを追加
      orderedNames.forEach((name) => {
        const cardType = this.cardTypeList.find(
          (ct) => ct.name === name
            && this.productList[ct.id] && this.productList[ct.id].length > 0
            && !addedIds.has(ct.id),
        );
        if (cardType) {
          filtered.push(cardType);
          addedIds.add(cardType.id);
        }
      });
      // 残りのカードタイプを元の順序で追加（MIX=999996は除外）
      this.cardTypeList.forEach((cardType) => {
        if (
          this.productList[cardType.id] && this.productList[cardType.id].length > 0
          && !addedIds.has(cardType.id)
          && cardType.id !== 999996
        ) {
          filtered.push(cardType);
          addedIds.add(cardType.id);
        }
      });
      this.availableCardTypes = filtered;
    },
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
    goToLogin() {
      // this.$router.push({ path: '/' });
      this.$store.dispatch('user/setShowLoginPage', true);
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    moveList(index) {
      this.$router.push({ path: '/pack-list', query: { index } });
    },
    showTokkyo() {
      window.open('https://xeroplace.jp/25/');
    },
    goMyPage() {
      if (this.currentUser.is_login === '1') {
        this.$store.dispatch('user/setShowMyPage', true);
      } else {
        this.$store.dispatch('user/setShowLoginPage', true);
      }
    },
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
      // this.showCardType = type;
    },
    changeCurrentPageCount(pageNumber) {
      // this.$store.dispatch('post/getPostList', { pageNumber });
      console.log(pageNumber);
    },
    savePost({ content, images }) {
      const postParams = {
        content,
        images,
      };
      this.$store.dispatch('post/savePost', { postParams });
    },
    closeSavePost() {
      this.inputBoard = false;
    },
    CardHideChange() {
      this.hideCard = true;
    },
    showInputArea() {
      this.inputBoard = true;
    },
    clickImage(image) {
      this.isImageModal = true;
      this.imageUrl = image;
    },
    changeCountry(countryId) {
      this.countryId = countryId;
    },
    saveCountry() {
      const postParams = {
        country_id: this.countryId,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    goToConfirmBuyProduct(pack, count) {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/' });
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      const postParams = {
        pack_id: pack.id,
        count: String(count),
      };
      this.currentPack = pack;
      this.count = count;
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    closeModal() {
      this.isOpenConfirm = false;
    },
    buyPack() {
      this.localBuyPack();
    },
    localBuyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { result } = buyPackResult;
          const { count } = buyPackResult.errors;
          if (result === -100) {
            this.localBuyPack();
            return;
          }
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    scrollToPackId(packId) {
      // パックIDに基づいてスクロール
      this.$nextTick(() => {
        const packElement = document.querySelector(
          `[data-pack-id="${packId}"]`,
        );
        if (packElement) {
          packElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.color_white {
  color: $white;
}

h2 {
  margin: 0;
  color: $black;
  margin-bottom: 10px;
}

._pack_list {
  margin: 0 auto 50px auto;
  max-width: 1600px;

  .banner_list {
    position: relative;

    ._title {
      color: $white;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    .list_button {
      border-radius: 5px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}

.top {
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  margin: 0 auto;

  .minny_link {
    text-align: center;
  }

  .product-list {
    display: flex;
    padding: 14px 0;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .banner {
    margin-bottom: 20px;
    width: 49.5%;
    @media screen and (max-width: 680px) {
      width: 100%;
    }
  }

  .double-flex {
    display: flex;
  }

  .shadow-button {
    min-width: 200px;
    max-width: 48%;
    width: 100%;
    height: 40px;
    margin: 20px auto 0;
  }

  .toiawase {
    text-align: center;
    color: $deepGray;
    margin-top: 20px;
  }

  .pc {
    display: block;
  }

  .sp {
    display: none;
  }
}

.message_base {
  margin-bottom: 0;
  margin-top: -80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 28px;
  align-items: center;

  .link {
    color: #285abe;
    cursor: pointer;
    transition: 0.4s;
    font-size: 34px;

    &:hover {
      opacity: 0.4;
    }
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #707070;
  width: 100%;

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 62px;
    }

    .message {
      font-size: 12px;
      margin-left: 15px;
      color: $white;
    }
  }
}

.twitter_block {
  width: 600px;
  margin: auto;

  iframe {
    width: 100%;
    height: 800px;
    border: none;
  }
}

.no_item_list {
  color: $white;
  text-align: center;
  margin-top: 20px;
}

.post_button_area {
  text-align: center;
  margin-bottom: 10px;
}

.post_list {
  background-color: $backColor;
  color: #fff;
  margin-top: 15px;
  padding: 15px;
  border-radius: 10px;
  .content {
    white-space: pre-wrap;
  }
  .images {
    display: flex;
    flex-wrap: wrap;
    .image {
      flex: 0 0 20%;
      max-width: 20%;
      padding: 5px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        cursor: pointer;
      }
    }
  }
}

.box-pager {
  margin-top: 20px;
}

.modal {
  box-shadow: 10px 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: auto;
  padding: 30px 30px;
  color: $mainColor;
  font-size: 20px;
  .modal-button-area {
    margin-top: 20px;
  }
}

@media screen and (max-width: 1200px) {
  .top {
    padding-top: 0;

    .pack_menu_list {
      justify-content: center;

      .pack_menu {
        width: 64px;
        min-width: 64px;
        font-size: 13px;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  ._pack_list {
    margin: 0;

    .banner_list {
      ._title {
        color: $white;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .top {
    .pc {
      display: none;
    }

    .sp {
      display: block;
    }

    .sub_title {
      padding: 5px 0;
      margin-top: 30px;

      span {
        font-size: 14px;
        margin-right: 4px;
      }

      div {
        font-size: 10px;
        width: 50px;
        padding: 10px 5px;
        border-radius: 100px;
        text-align: center;

        &:hover {
          opacity: 1;
        }
      }
    }

    .banner_base {
      margin: 0 10px 25px 10px;
      width: 100%;
      min-width: 30vw;
      margin-bottom: 25px;
      @media screen and (max-width: 400px) {
        margin: 0 0 20px 0;
      }
    }
  }

  .twitter_block {
    width: auto;
    margin: 0 20px;
    height: auto;
    overflow-y: auto;
  }
}

.overlay {
  overflow: auto;
}

.pack-confirm {
  border-radius: 10px;
  max-width: 600px;
  min-width: 400px;
  padding: 30px;
  position: relative;
  .block {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 10px 20px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
    div {
      text-align: center;
    }
  }
  .close_button {
    position: absolute;
    right: 7px;
    top: 15px;
  }
  @media screen and (max-width: $mobileWidth) {
    max-width: 90vw;
    min-width: 320px;
    padding: 40px 20px;
    min-height: 400px;
    .block {
      padding: 20px 10px;
    }
  }
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  .modal-button-area {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 40px 0;
      align-items: center;
      gap: 25px;
      .purchase-btn {
        width: 100%;
        max-width: 165px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    // justify-content: flex-start!important;
    // align-items: flex-start!important;
    margin-top: 70px;
    padding-bottom: 70px;
    .overlay_image {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.comming_soon {
  color: #fff;
  text-align: center;
  font-size: 36px;
  padding: 40px 0;
}

.register-country {
  .register-country-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .register-country-select {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay.register-country {
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
